import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import moment from 'moment';

dayjs.extend(updateLocale);

export type WeekStartDayType = 'sunday' | 'monday' | 'saturday';

export const DEFAULT_WEEK_START_DAY: WeekStartDayType = 'sunday';

const WEEK_START_DAY_INDEX: Record<WeekStartDayType, number> = {
  sunday: 0,
  monday: 1,
  saturday: 6,
};

/** Reads the saved week start from calendar preferences, falling back to Sunday. */
export const getSavedWeekStartDay = (calendarPreferences?: object): WeekStartDayType => {
  const saved = (calendarPreferences as { weekStartDay?: string } | undefined)?.weekStartDay;
  return saved && saved in WEEK_START_DAY_INDEX
    ? (saved as WeekStartDayType)
    : DEFAULT_WEEK_START_DAY;
};

/**
 * Makes dayjs (`startOf('week')`, `weekday()`) and moment (react-big-calendar) agree on the first
 * day of the week for their current locale.
 */
export const applyWeekStartDay = (weekStartDay: WeekStartDayType) => {
  const dow = WEEK_START_DAY_INDEX[weekStartDay];

  dayjs.updateLocale(dayjs.locale(), { weekStart: dow });
  moment.updateLocale(moment.locale(), { week: { dow, doy: 7 + dow - 1 } });
};
